import { render, staticRenderFns } from "./departmentOchart.vue?vue&type=template&id=2a6c5962&scoped=true&"
import script from "./departmentOchart.vue?vue&type=script&lang=js&"
export * from "./departmentOchart.vue?vue&type=script&lang=js&"
import style0 from "./departmentOchart.vue?vue&type=style&index=0&lang=css&"
import style1 from "../../statistics/css/departmentOchart.css?vue&type=style&index=1&id=2a6c5962&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a6c5962",
  null
  
)

export default component.exports